import type {
  CompteComptable,
  MappingComptable,
} from '../../serveur/src/comptabilite/types.ts'
import type { FicheEvenement } from '../../serveur/src/evenements/index.ts'
export type CompteGlItem = Pick<
  MappingComptable,
  'compte_debit' | 'compte_credit' | 'traitement' | 'taxes'
>
export type DisponibilitesItem = Partial<
  Pick<
    FicheEvenement,
    | 'jours'
    | 'ouverture'
    | 'fermeture'
    | 'duree_minimum'
    | 'duree_maximum'
    | 'pas_minutes'
    | 'horizon_jours'
    | 'date'
    | 'debut'
    | 'fin'
    | 'capacite'
    | 'maximum_par_inscription'
  >
>
export interface FicheInventaire {
  nom: string
  description: string
  categorie?: string
  type: 'espace' | 'equipement' | 'produit' | 'activite'
  nature: 'location' | 'reservation' | 'achat'
  prix_cents: number
  unite: 'heure' | 'jour' | 'reservation' | 'personne' | 'unite'
  quantite: number
  actif: boolean
  ressource_cle?: string
  compte_gl?: CompteGlItem
  disponibilites?: DisponibilitesItem
}
export interface ItemInventaire {
  id: string
  version_id: string
  version: number
  fiche: FicheInventaire
  ressource_id: string | null
  services: Array<{ cle: string; nom: string }>
}
export interface RelationInventaire {
  id: string
  item_a: string
  item_b: string
  mode: 'chevauchement' | 'journee'
}
export interface DonneesInventaire {
  items: ItemInventaire[]
  comptes: CompteComptable[]
  taxes?: Array<{ nom: string; taux?: number }>
  relations: RelationInventaire[]
  fuseau?: string
}
export const TYPES_INVENTAIRE = {
  espace: 'Espace',
  equipement: 'Équipement',
  produit: 'Autre élément',
  activite: 'Activité',
}
export const UNITES_INVENTAIRE = {
  heure: 'par heure',
  jour: 'par jour',
  reservation: 'par réservation',
  personne: 'par personne',
  unite: 'par unité',
}
export const prixInventaire = (cents: number) =>
  new Intl.NumberFormat('fr-CA', { style: 'currency', currency: 'CAD' }).format(
    cents / 100,
  )
